import {
  BUSINESS_TYPE_OPTIONS,
  PREFERED_LANGUAGE_OPTIONS,
  PROBABILITY_OPTIONS,
  ZOOM_MEETING_STATUS_OPTIONS,
} from "./filterFieldsOptions";

export const moduleFilterFields = {
  leads: [
    {
      key: "firstName",
      label: "First Name",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "lastName",
      label: "Last Name",
      type: "string",
      isQueryParam: false,
    },
    { key: "email", label: "Email", type: "string", isQueryParam: false },
    { key: "mobile", label: "Phone", type: "string", isQueryParam: false },

    {
      key: "currentStatus.name",
      label: "Status",
      type: "select",
      options: [],
      isQueryParam: true,
      url: "/company/leads/contact-stage/:ofCompany",
    },
    {
      key: "meetingStatus",
      label: "Zoom Meeting Status",
      type: "select",
      options: ZOOM_MEETING_STATUS_OPTIONS,
      isQueryParam: true,
      url: "",
    },
    {
      key: "probability",
      label: "Probability",
      type: "select",
      options: PROBABILITY_OPTIONS,
      isQueryParam: true,
      url: "",
    },
    {
      key: "language",
      label: "Preferred Language",
      type: "select",
      options: PREFERED_LANGUAGE_OPTIONS,
      isQueryParam: true,
      url: "",
    },
    {
      key: "businessType",
      label: "Business Type",
      type: "select",
      options: BUSINESS_TYPE_OPTIONS,
      isQueryParam: true,
      url: "",
    },

    {
      key: "leadSource",
      label: "Lead Source",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "referenceSource",
      label: "Reference Source",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "description",
      label: "Description",
      type: "string",
      isQueryParam: false,
    },
    { key: "city", label: "City", type: "string", isQueryParam: false },
    { key: "state", label: "State", type: "string", isQueryParam: false },
    {
      key: "compaignName",
      label: "Compaign Name",
      type: "string",
      isQueryParam: false,
    },

    {
      key: "createdTime",
      label: "Created At",
      type: "date",
      isQueryParam: true,
    },
    {
      key: "lastActivityDate",
      label: "Updated At",
      type: "date",
      isQueryParam: true,
    },
    {
      key: "productCategory",
      label: "Product Category",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "productInterested.name",
      label: "Product Interested",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "clientCode",
      label: "Client Code",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "question1",
      label: "Question 1",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "question2",
      label: "Question 2",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "question3",
      label: "Question 3",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "referenceByFranchiseCode",
      label: "Reference By Franchise Code",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "referenceByFranchiseMobile",
      label: "Reference By Franchise Mobile",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "referenceByFranchiseEmail",
      label: "Reference By Franchise Email",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "referenceByFranchiseName",
      label: "Reference By Franchise Name",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "franchiseDetails",
      label: "Franchise Details",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "franchiseRM",
      label: "Franchise RM",
      type: "string",
      isQueryParam: false,
    },

    {
      key: "assignedTo",
      label: "Caller",
      type: "select",
      options: [],
      isQueryParam: true,
      url: "/user/get-user-by-role/caller",
      valueKey: "_id",
    },
    // {
    //   key: "ofCompany",
    //   label: "Company",
    //   type: "select",
    //   options: [],
    //   isQueryParam: true,
    //   url: "/company",
    //   valueKey: "_id",
    // },
  ],
  duplicateLeads: [
    {
      key: "firstName",
      label: "First Name",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "lastName",
      label: "Last Name",
      type: "string",
      isQueryParam: false,
    },
    { key: "email", label: "Email", type: "string", isQueryParam: false },
    { key: "mobile", label: "Phone", type: "string", isQueryParam: false },

    {
      key: "probability",
      label: "Probability",
      type: "select",
      options: PROBABILITY_OPTIONS,
      isQueryParam: true,
      url: "",
    },
    {
      key: "language",
      label: "Preferred Language",
      type: "select",
      options: PREFERED_LANGUAGE_OPTIONS,
      isQueryParam: true,
      url: "",
    },
    {
      key: "businessType",
      label: "Business Type",
      type: "select",
      options: BUSINESS_TYPE_OPTIONS,
      isQueryParam: true,
      url: "",
    },
    {
      key: "leadSource",
      label: "Lead Source",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "referenceSource",
      label: "Reference Source",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "salesRemark",
      label: "Sales Remark",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "description",
      label: "Description",
      type: "string",
      isQueryParam: false,
    },
    { key: "city", label: "City", type: "string", isQueryParam: false },
    { key: "state", label: "State", type: "string", isQueryParam: false },
    {
      key: "compaignName",
      label: "Compaign Name",
      type: "string",
      isQueryParam: false,
    },

    // {
    //   key: "assignedTo.name",
    //   label: "Caller",
    //   type: "string",
    //   isQueryParam: true,
    // },
    // {
    //   key: "ofCompany._id",
    //   label: "Company",
    //   type: "string",
    //   isQueryParam: true,
    // },
    // {
    {
      key: "createdTime",
      label: "Created At",
      type: "date",
      isQueryParam: true,
    },
    {
      key: "lastActivityDate",
      label: "Updated At",
      type: "date",
      isQueryParam: true,
    },
  ],
  products: [
    {
      key: "product.name",
      label: "Product Name",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "name",
      label: "Product Category",
      type: "string",
      isQueryParam: false,
    },
    // {
    //   key: "ofCompany",
    //   label: "Company",
    //   type: "string",
    //   isQueryParam: false,
    // },
    {
      key: "createdAt",
      label: "Created At",
      type: "date",
      isQueryParam: false,
    },
    {
      key: "updatedAt",
      label: "Updated At",
      type: "date",
      isQueryParam: false,
    },
  ],
  deals: [
    {
      key: "firstName",
      label: "First Name",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "lastName",
      label: "Last Name",
      type: "string",
      isQueryParam: false,
    },
    { key: "email", label: "Email", type: "string", isQueryParam: false },
    { key: "mobile", label: "Phone", type: "string", isQueryParam: false },
    {
      key: "currentStatus.name",
      label: "Status",
      type: "select",
      options: [],
      isQueryParam: true,
      url: "/company/deals/contact-stage/:ofCompany",
    },
    {
      key: "verificationRecord.paymentStatus",
      label: "Payment Status",
      type: "select",
      options: [
        { name: "Pending" },
        { name: "Approved" },
        { name: "Rejected" },
      ],
      isQueryParam: true,
      url: "",
    },
    {
      key: "verificationRecord[paymentDate]",
      label: "Payment Date",
      type: "date",
      isQueryParam: true,
    },
    {
      key: "meetingStatus",
      label: "Zoom Meeting Status",
      type: "select",
      options: ZOOM_MEETING_STATUS_OPTIONS,
      isQueryParam: true,
      url: "",
    },

    {
      key: "probability",
      label: "Probability",
      type: "select",
      options: PROBABILITY_OPTIONS,
      isQueryParam: true,
      url: "",
    },
    {
      key: "language",
      label: "Preferred Language",
      type: "select",
      options: PREFERED_LANGUAGE_OPTIONS,
      isQueryParam: true,
      url: "",
    },
    {
      key: "businessType",
      label: "Business Type",
      type: "select",
      options: BUSINESS_TYPE_OPTIONS,
      isQueryParam: true,
      url: "",
    },
    {
      key: "leadSource",
      label: "Lead Source",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "referenceSource",
      label: "Reference Source",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "description",
      label: "Description",
      type: "string",
      isQueryParam: false,
    },
    { key: "city", label: "City", type: "string", isQueryParam: false },
    { key: "state", label: "State", type: "string", isQueryParam: false },

    {
      key: "compaignName",
      label: "Compaign Name",
      type: "string",
      isQueryParam: false,
    },

    {
      key: "createdTime",
      label: "Lead Created Time",
      type: "date",
      isQueryParam: true,
    },

    {
      key: "leadToDealOn",
      label: "Created At",
      type: "date",
      isQueryParam: true,
    },
    {
      key: "lastActivityDate",
      label: "Updated At",
      type: "date",
      isQueryParam: true,
    },

    {
      key: "productCategory",
      label: "Product Category",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "productInterested.name",
      label: "Product Interested",
      type: "string",
      isQueryParam: false,
    },

    {
      key: "referenceByFranchiseCode",
      label: "Reference By Franchise Code",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "referenceByFranchiseMobile",
      label: "Reference By Franchise Mobile",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "referenceByFranchiseEmail",
      label: "Reference By Franchise Email",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "referenceByFranchiseName",
      label: "Reference By Franchise Name",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "franchiseDetails",
      label: "Franchise Details",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "franchiseRM",
      label: "Franchise RM",
      type: "string",
      isQueryParam: false,
    },

    {
      key: "assignedTo",
      label: "Caller",
      type: "select",
      options: [],
      isQueryParam: true,
      url: "/user/get-user-by-role/caller",
      valueKey: "_id",
    },

    // {
    //   key: "ofCompany",
    //   label: "Company",
    //   type: "select",
    //   options: [],
    //   isQueryParam: true,
    //   url: "/company",
    // },
    {
      key: "question1",
      label: "Question 1",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "question2",
      label: "Question 2",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "question3",
      label: "Question 3",
      type: "string",
      isQueryParam: false,
    },
  ],
  users: [
    {
      key: "name",
      label: "Name",
      type: "string",
      isQueryParam: false,
    },
    { key: "email", label: "Email", type: "string", isQueryParam: false },
    { key: "mobile", label: "Phone", type: "string", isQueryParam: false },
    {
      key: "status",
      label: "Status",
      type: "string",
      isQueryParam: false,
    },
    // {
    //   key: "role.name",
    //   label: "Role",
    //   type: "string",
    //   isQueryParam: false,
    // },
    // {
    //   key: "ofCompany._id",
    //   label: "Company",
    //   type: "string",
    //   isQueryParam: true,
    // },
    {
      key: "createdAt",
      label: "Created At",
      type: "date",
      isQueryParam: true,
    },
    {
      key: "updatedAt",
      label: "Updated At",
      type: "date",
      isQueryParam: true,
    },
  ],
  accounts: [
    {
      key: "firstName",
      label: "Name",
      type: "string",
      isQueryParam: false,
    },
    { key: "email", label: "Email", type: "string", isQueryParam: false },

    // {
    //   key: "ofCompany._id",
    //   label: "Company",
    //   type: "string",
    //   isQueryParam: true,
    // },
    {
      key: "createdAt",
      label: "Created At",
      type: "date",
      isQueryParam: true,
    },
    {
      key: "updatedAt",
      label: "Updated At",
      type: "date",
      isQueryParam: true,
    },
  ],
  enrollment: [
    {
      key: "fullName",
      label: "Full Name",
      type: "string",
      isQueryParam: false,
    },
    { key: "email", label: "Email", type: "string", isQueryParam: false },

    {
      key: "mobile",
      label: "Mobile",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "enrolledOn",
      label: "Enrolled On",
      type: "date",
      isQueryParam: true,
    },
    {
      key: "informationCallDate",
      label: "Information Call Date",
      type: "date",
      isQueryParam: true,
    },
    {
      key: "joiningProcessCallDate",
      label: "Joining Process Call Date",
      type: "date",
      isQueryParam: true,
    },
    {
      key: "serviceFirstCallOn",
      label: "Service First Call On",
      type: "date",
      isQueryParam: true,
    },
    {
      key: "serviceSecondCallOn",
      label: "Service Second Call On",
      type: "date",
      isQueryParam: true,
    },
    {
      key: "serviceThirdCallOn",
      label: "Service Third Call On",
      type: "date",
      isQueryParam: true,
    },
    {
      key: "course",
      label: "Course",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "medium",
      label: "Medium",
      type: "string",
      isQueryParam: false,
    },
  ],
  profilingForm: [
    { key: "email", label: "Email", type: "string", isQueryParam: false },

    {
      key: "mobile",
      label: "Mobile",
      type: "string",
      isQueryParam: false,
    },
    {
      key: "submittedOn",
      label: "Submitted On",
      type: "date",
      isQueryParam: true,
    },
    {
      key: "profilingformStatus.isCompleted",
      label: "Completed Status",
      type: "select",
      options: [
        { name: "true", value: true },
        { name: "false", value: false },
      ],
      isQueryParam: true,
      url: "",
    },
    {
      key: "isInEnrollment",
      label: "Enrolled Student",
      type: "select",
      options: [
        { name: "true", value: true },
        { name: "false", value: false },
      ],
      isQueryParam: true,
      url: "",
    },
  ],
};
